import generateFloat from '../generateFloat'

export type CalculateKenoBetResultOptions = {
  serverSeed: string
  clientSeed: string
  nonce: number
}

export default function calculateKenoBetResult(
  options: CalculateKenoBetResultOptions
) {
  const { serverSeed, clientSeed, nonce } = options

  const numbers = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
  ]

  for (let i = 0; i < 10; i++) {
    const float = generateFloat({ serverSeed, clientSeed, nonce, round: i })
    const j = i + Math.floor(float * (numbers.length - i))
    const temp = numbers[i]
    numbers[i] = numbers[j]
    numbers[j] = temp
  }

  const result = numbers.slice(0, 10)

  return result
}
